import { render } from "./DonationsPage.vue?vue&type=template&id=015401d4"
import script from "./DonationsPage.vue?vue&type=script&lang=js"
export * from "./DonationsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__